//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWeek, format } from "date-format-parse"
import IconButton from "./icon-button"
import { chunk } from "../util/base"
import { createDate, getCalendar, isValidDate } from "../util/date"
import { getLocale } from "../locale"

export default {
  name: "TableDate",
  components: { IconButton },
  inject: {
    getLocale: {
      default: () => getLocale
    },
    getWeek: {
      default: () => getWeek
    },
    prefixClass: {
      default: "mx"
    },
    onDateMouseEnter: {
      default: undefined
    },
    onDateMouseLeave: {
      default: undefined
    }
  },
  props: {
    calendar: {
      type: Date,
      default: () => new Date()
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    titleFormat: {
      type: String,
      default: "YYYY-MM-DD"
    },
    getRowClasses: {
      type: Function,
      default: () => []
    },
    getCellClasses: {
      type: Function,
      default: () => []
    }
  },
  computed: {
    firstDayOfWeek() {
      return this.getLocale().formatLocale.firstDayOfWeek || 0
    },
    yearMonth() {
      const { yearFormat, monthBeforeYear, monthFormat = "MMM" } = this.getLocale()
      const yearLabel = {
        panel: "year",
        label: this.formatDate(this.calendar, yearFormat)
      }
      const monthLabel = {
        panel: "month",
        label: this.formatDate(this.calendar, monthFormat)
      }
      return monthBeforeYear ? [monthLabel, yearLabel] : [yearLabel, monthLabel]
    },
    days() {
      const locale = this.getLocale()
      const days = locale.days || locale.formatLocale.weekdaysMin
      return days.concat(days).slice(this.firstDayOfWeek, this.firstDayOfWeek + 7)
    },
    dates() {
      const year = this.calendar.getFullYear()
      const month = this.calendar.getMonth()
      const arr = getCalendar({
        firstDayOfWeek: this.firstDayOfWeek,
        year,
        month
      })
      return chunk(arr, 7)
    }
  },
  methods: {
    getNextCalendar(diffMonth) {
      const year = this.calendar.getFullYear()
      const month = this.calendar.getMonth()
      return createDate(year, month + diffMonth)
    },
    handleIconLeftClick() {
      this.$emit("changecalendar", this.getNextCalendar(-1), "last-month")
    },
    handleIconRightClick() {
      this.$emit("changecalendar", this.getNextCalendar(1), "next-month")
    },
    handleIconDoubleLeftClick() {
      this.$emit("changecalendar", this.getNextCalendar(-12), "last-year")
    },
    handleIconDoubleRightClick() {
      this.$emit("changecalendar", this.getNextCalendar(12), "next-year")
    },
    handlePanelChange(panel) {
      this.$emit("changepanel", panel)
    },
    handleMouseEnter(cell) {
      if (typeof this.onDateMouseEnter === "function") {
        this.onDateMouseEnter(cell)
      }
    },
    handleMouseLeave(cell) {
      if (typeof this.onDateMouseLeave === "function") {
        this.onDateMouseLeave(cell)
      }
    },
    handleCellClick(evt) {
      let { target } = evt
      if (target.tagName.toUpperCase() === "DIV") {
        target = target.parentNode
      } else if (target.tagName.toUpperCase() === "SPAN") {
        target = target.parentNode.parentNode
      }
      const index = target.getAttribute("data-row-col")
      if (index) {
        const [row, col] = index.split(",").map(v => parseInt(v, 10))
        const date = this.dates[row][col]
        this.$emit("select", new Date(date))
      }
    },
    formatDate(date, fmt) {
      return format(date, fmt, { locale: this.getLocale().formatLocale })
    },
    getCellTitle(date) {
      const fmt = this.titleFormat
      return this.formatDate(date, fmt)
    },
    getWeekNumber(date) {
      return this.getWeek(date, this.getLocale().formatLocale)
    }
  }
}
